// React
import React from 'react';
// Mantine
import { Flex } from '@mantine/core';
import { MRT_TableInstance } from 'mantine-react-table';

// Custom Components
import { CreateRowButton } from 'components/common/CreateRowButton';
import { UploadFileButton } from 'pages/eobs/components/EOBUploadFileButton';

// Interfaces
import { EOB } from 'interfaces';

interface EOBToolBarProps {
  table: MRT_TableInstance<EOB>;
  handleSubmitFile: () => void;
  eobFile: File | null;
  setEobFile: React.Dispatch<React.SetStateAction<File | null>>;
}

export const EOBToolBar = ({
  table,
  handleSubmitFile,
  eobFile,
  setEobFile,
}: EOBToolBarProps) => {
  return (
    <Flex align={'center'} justify={'center'} gap={'sm'}>
      <CreateRowButton table={table} type="EOB" />
      <UploadFileButton
        table={table}
        eobFile={eobFile}
        setEobFile={setEobFile}
        handleSubmitFile={handleSubmitFile}
      />
    </Flex>
  );
};
